// Header.js
import React, { useState, useEffect } from 'react';
import './Header.css';
import logo from '../assets/logo.png';
<a href="/" className="site-title">Adept Knowledge Technologies</a>

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth <= 768);
    checkScreen();
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="site-header">
  <a href="#home" className="logo-link">
    <div className="logo-area" data-aos="fade-up">
      <img src={logo} alt="Logo" className="logo-img" />
      <span className="site-title">Adept Knowledge Technologies</span>
    </div>
  </a>

      

      {isMobile ? (
        <>
          <div
  className={`hamburger ${menuOpen ? 'open' : ''}`}
  onClick={toggleMenu}

>

            <span />
            <span />
            <span />
          </div>

          <div className={`mobile-menu ${menuOpen ? 'show' : ''}`}>
            <ul>
              <li><a href="#home" onClick={closeMenu}>Home</a></li>
              <li><a href="#about" onClick={closeMenu}>About</a></li>
              <li><a href="#blog" onClick={closeMenu}>Blog</a></li>
              <li><a href="#contact" onClick={closeMenu}>Contact</a></li>
            </ul>
          </div>

          {menuOpen && <div className="menu-backdrop" onClick={closeMenu}></div>}
        </>
      ) : (
        <nav>
          <ul className="nav-links">
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#blog">Blog</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </nav>
      )}
    </header>
  );
};

export default Header;
